import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { addPublicICSSubscription, deletePublicICSSubscription, getPublicICSSubscription } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const usePublicICSSubscriptionQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'public-ics-subscription' ],
    queryFn: getPublicICSSubscription,
    select: res => res.data,
    ...opts,
  });
};


export const useDeletePublicICSSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePublicICSSubscription,
    onSuccess: async () => {
      await queryClient.invalidateQueries([ 'public-ics-subscription' ]);
    }
  });
};


export const useAddPublicICSSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addPublicICSSubscription,
    onSuccess: async () => {
      await queryClient.invalidateQueries([ 'public-ics-subscription' ]);
    }
  });
};
